import React, { FC, useEffect, useRef } from "react";
import styles from "./Exchanger.module.scss";
import { PUBLIC_ICON, PUBLIC_IMAGE } from "../../constants";
import FormExchanger from "../../components/FormExchanger/FormExchanger";
import { observer } from "mobx-react-lite";
import RecentExchanges from "../../components/RecentExchanges/RecentExchanges";
import Advantages from "../../components/Advantages/Advantages";
import Reliability from "../../components/Reliability/Reliability";
import { Helmet } from "react-helmet";
import { MatrixCryptoBanner } from "../../components/UI/MatrixCryptoBanner/MatrixCryptoBanner";
import formStore from "../../stores/formStore";

const Exchanger: FC = () => {
  const formImage = PUBLIC_IMAGE + "Exchanger-form-img.svg";

  const formRef = useRef<HTMLDivElement>(null);
  const stepOneRef = useRef<HTMLDivElement>(null);
  const stepTwoRef = useRef<HTMLDivElement>(null);
  const stepThreeRef = useRef<HTMLDivElement>(null);
  const stepFourRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (formStore.hitsSteps === 1) {
      stepOneRef.current?.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  }, [formStore.hitsSteps]);

  useEffect(() => {
    if (formStore.hitsSteps === 2) {
      stepTwoRef.current?.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  }, [formStore.hitsSteps]);

  useEffect(() => {
    if (formStore.hitsSteps === 3) {
      stepThreeRef.current?.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  }, [formStore.hitsSteps]);

  useEffect(() => {
    if (formStore.hitsSteps === 4) {
      stepFourRef.current?.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  }, [formStore.hitsSteps]);

  useEffect(() => {
    if (formStore.hitsSteps === 0) {
      formRef.current?.scrollIntoView({
        behavior: "smooth",
      });
    }
  }, [formStore.hitsSteps]);

  const scrollToForm = () => {
    formRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <>
      <Helmet>
        <title>Exchanger</title>
        <link rel="icon" href={PUBLIC_ICON + "Alfa.svg"} />
      </Helmet>
      {formStore.hitsSteps > 0 && (
        <div
          className={styles.overlay}
          onClick={() => formStore.setHitsStepZero()}
        />
      )}
      <div className={styles.main}>
        <div className={styles.main__wrapper}>
          <div className={styles.from__wrapper}>
            <div className={styles.form__imageWrapper}>
              <img src={formImage} alt="formImage" />
            </div>
            <div className={styles.form__exchangerWrapper} ref={formRef}>
              <div className={styles.from__BannerWrapper}>
                <MatrixCryptoBanner height={180}></MatrixCryptoBanner>
              </div>
              <div
                ref={stepOneRef}
                className={
                  formStore.hitsSteps == 1
                    ? `${styles.form__hintsOne} ${styles.form__hintsStyles}`
                    : `${styles.form__hintsOneHidden} ${styles.form__hintsStyles}`
                }
              >
                1.Select the sending currency and enter the amount.{" "}
                <div className={styles.form__hintsStepsOne}>
                  {/* <div
                    className={styles.form__hintsStepBack}
                    onClick={() => formStore.setHitsStepMinus()}
                  >
                    <img src={PUBLIC_IMAGE + "form__hintsStepBack.svg"}></img>
                  </div> */}
                  <div className={styles.form__hintsStepNumber}>1/4</div>
                  <div
                    className={styles.form__hintsStepForward}
                    onClick={() => formStore.setHitsStepPlus()}
                  >
                    <img
                      src={PUBLIC_IMAGE + "form__hintsStepForward.svg"}
                    ></img>
                  </div>
                </div>
                <div className={styles.form__hintsArrowBottomOne}>
                  <img src={PUBLIC_IMAGE + "form__hintsArrowBottom.svg"}></img>
                </div>
              </div>
              <div
                ref={stepTwoRef}
                className={
                  formStore.hitsSteps == 2
                    ? `${styles.form__hintsTwo} ${styles.form__hintsStyles}`
                    : `${styles.form__hintsOneHidden} ${styles.form__hintsStyles}`
                }
              >
                2.Choose the currency you want to receive.
                <div className={styles.form__hintsStepsTwo}>
                  <div
                    className={styles.form__hintsStepBack}
                    onClick={() => formStore.setHitsStepMinus()}
                  >
                    <img src={PUBLIC_IMAGE + "form__hintsStepBack.svg"}></img>
                  </div>
                  <div className={styles.form__hintsStepNumber}>2/4</div>
                  <div
                    className={styles.form__hintsStepForward}
                    onClick={() => formStore.setHitsStepPlus()}
                  >
                    <img
                      src={PUBLIC_IMAGE + "form__hintsStepForward.svg"}
                    ></img>
                  </div>
                </div>
                <div className={styles.form__hintsArrowBottomTwo}>
                  <img src={PUBLIC_IMAGE + "form__hintsArrowBottom.svg"}></img>
                </div>
              </div>
              <div
                ref={stepThreeRef}
                className={
                  formStore.hitsSteps == 3
                    ? `${styles.form__hintsThree} ${styles.form__hintsStyles}`
                    : `${styles.form__hintsOneHidden} ${styles.form__hintsStyles}`
                }
              >
                3.Enter your contact details so we can reach you if needed.
                <div className={styles.form__hintsStepsThree}>
                  <div
                    className={styles.form__hintsStepBack}
                    onClick={() => formStore.setHitsStepMinus()}
                  >
                    <img src={PUBLIC_IMAGE + "form__hintsStepBack.svg"}></img>
                  </div>
                  <div className={styles.form__hintsStepNumber}>3/4</div>
                  <div
                    className={styles.form__hintsStepForward}
                    onClick={() => formStore.setHitsStepPlus()}
                  >
                    <img
                      src={PUBLIC_IMAGE + "form__hintsStepForward.svg"}
                    ></img>
                  </div>
                </div>
                <div className={styles.form__hintsArrowBottomThree}>
                  <img src={PUBLIC_IMAGE + "form__hintsArrowBottom.svg"}></img>
                </div>
              </div>
              <div
                ref={stepFourRef}
                className={
                  formStore.hitsSteps == 4
                    ? `${styles.form__hintsFour} ${styles.form__hintsStyles}`
                    : `${styles.form__hintsOneHidden} ${styles.form__hintsStyles}`
                }
              >
                4.Start a search through over 1.5M quotes to find the best rate.
                <div className={styles.form__hintsStepsFour}>
                  <div
                    className={styles.form__hintsStepBack}
                    onClick={() => formStore.setHitsStepMinus()}
                  >
                    <img src={PUBLIC_IMAGE + "form__hintsStepBack.svg"}></img>
                  </div>
                  <div className={styles.form__hintsStepNumber}>4/4</div>
                  <div
                    className={styles.form__hintsStepForward}
                    onClick={() => formStore.setHitsStepZero()}
                  >
                    <img
                      src={PUBLIC_IMAGE + "form__hintsStepForward.svg"}
                    ></img>
                  </div>
                </div>
                <div className={styles.form__hintsArrowBottomFour}>
                  <img src={PUBLIC_IMAGE + "form__hintsArrowBottom.svg"}></img>
                </div>
              </div>
              <FormExchanger />
            </div>
          </div>
          <RecentExchanges />
          <Advantages />
          <Reliability onScrollToForm={scrollToForm} />
        </div>
        {formStore.hitsSteps > 0 && (
          <div className={styles.form__hintsStepsButtons}>
            <div
              className={styles.form__hintsStepsButtonBack}
              onClick={() => formStore.setHitsStepMinus()}
            >
              <img src={PUBLIC_IMAGE + "form__hintsStepBack.svg"}></img>
            </div>
            <div
              className={styles.form__hintsStepsButtonClose}
              onClick={() => formStore.setHitsStepZero()}
            >
              <div>Step {formStore.hitsSteps}/4</div>
              <div className={styles.form__hintsStepsButtonCloseText}>
                Tap to close
              </div>
            </div>
            <div
              className={styles.form__hintsStepsButtonNext}
              onClick={
                formStore.hitsSteps > 0 && formStore.hitsSteps < 4
                  ? () => formStore.setHitsStepPlus()
                  : () => formStore.setHitsStepZero()
              }
            >
              {" "}
              <img src={PUBLIC_IMAGE + "form__hintsStepForward.svg"}></img>
            </div>
          </div>
        )}
      </div>
    </>
  );
};
export default observer(Exchanger);
